module.exports = __webpack_public_path__ + "img/option-card-right-modal-icon.99b2ddaa.svg";